import { Injectable } from '@angular/core';
import { Toast } from 'src/app/components/toast/models/toast.model';

@Injectable({
	providedIn: 'root'
})
export class ToastService {
	public static get toasts(): Toast[] {
		return ToastService._toasts;
	}

	// tslint:disable-next-line:variable-name
	private static _toasts: Toast[] = [];

	public static pushToast(model: Toast): void {
		model.isVisible = true;
		ToastService._toasts.push(model);

		setTimeout(() => model.isVisible = false, model.timeout || 3000);
	}
}
